import { throttle } from './throttle';

/**
 * Detects scroll direction and calls the callback with 'up' or 'down'.
 * @param {function} callback - Function to call with direction ('up' or 'down')
 * @param {number} throttleDelay - Optional throttle delay in ms (default: 50)
 */
export function onScrollDirection(callback, throttleDelay = 50) {
  let lastScrollY = window.scrollY;
  let ticking = false;

  const handleScroll = throttle(() => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY) {
      callback('down');
    } else if (currentScrollY < lastScrollY) {
      callback('up');
    }
    lastScrollY = currentScrollY;
  }, throttleDelay);

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Return a cleanup function to remove the event listener
  return () => {
    window.removeEventListener('scroll', handleScroll, { passive: true });
  };
}
